import { supabase } from '../lib/supabase'

export type UserRole = 'developer' | 'designer' | 'founder' | 'creator' | 'student' | 'other'
export type UserInterest = 'ecommerce' | 'saas' | 'portfolio' | 'blog' | 'landing' | 'internal' | 'mobile' | 'social'

export interface UserProfile {
  user_id: string
  display_name: string | null
  avatar_url: string | null
  role: UserRole | null
  interests: UserInterest[] | null
  onboarding_completed: boolean
}

/** Fetch current user's profile from cogo.user_profiles */
export async function fetchProfile(userId: string): Promise<UserProfile | null> {
  const { data, error } = await supabase
    .schema('cogo')
    .from('user_profiles')
    .select('user_id, display_name, avatar_url, role, interests, onboarding_completed')
    .eq('user_id', userId)
    .single()

  if (error || !data) return null
  return data as UserProfile
}

/** Complete onboarding — save role, interests, display_name */
export async function completeOnboarding(params: {
  userId: string
  displayName: string
  role: UserRole
  interests: UserInterest[]
}): Promise<void> {
  const { error } = await supabase.schema('cogo').rpc('upsert_user_profile', {
    p_user_id: params.userId,
    p_display_name: params.displayName,
    p_role: params.role,
    p_interests: params.interests,
    p_onboarding_completed: true,
  })
  if (error) throw error
}
